import {TranslationKey} from '@enums'
import {Grid} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {useParentCompanyFormModel} from './parent-company-form-model'

/**
 * Parent Company Form page
 */
export function ParentCompanyFormPage() {
  const {parentCompanyGeneralFormFields, t, onSubmit, onDiscard} = useParentCompanyFormModel()

  return (
    <>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {parentCompanyGeneralFormFields.map((item, index) => (
            <Grid item sm={6} key={`parent-company-general-form-field-${index}`}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Discard), onClick: onDiscard}}
        rightButton={{label: t(TranslationKey.Save), onClick: onSubmit}}
      />
    </>
  )
}
